import React, { useEffect, useState } from "react";
import { Row, Col, Container, Modal } from "react-bootstrap";
import Header from "../../src/components/header";
import Footer from "../components/footer";
import Buysell from "../../src/components/buysell";
import Newbuysell from "../components/Newbuysell";
import Favourite from "../components/favourite";
import { useNavigate, useParams } from "react-router-dom";
import ExportApi from "../api/ExportApi";
import Heart from "react-heart";
import {FacebookShareButton,FacebookIcon,TwitterShareButton,TwitterIcon,PinterestShareButton,PinterestIcon,EmailShareButton,EmailIcon} from "react-share";
import Login from "../components/Login";
import { IoShareOutline } from "react-icons/io5";
import { Helmet } from "react-helmet-async";
import InfoSvg from "../assets/svg/infoSvg";
import {DEFAULT_PRODUCT_DESCRIPTION} from "../helper/constant"
import WarningSvg from "../assets/svg/warningSvg";
import QuestionMarkSvg from "../assets/svg/QuestionMarkSvg";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";


export default function Product() {
  const Params = useParams();
  const navigate = useNavigate();
  const path = window.location.href;
  const [show, setShow] = useState(false);
  const [Data, setData] = useState();
  const [filterBrand, setFilterBrand] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [Compare, setCompare] = useState([]);
  const [CompareData, setCompareData] = useState([]);
  const [askAmount, setAskAmount] = useState();
  const [bidAmount, setBidAmount] = useState();
  const [isLoading, setLoading] = useState(false);
  const [secondHouseAskPrice, setSecondHouseAskPrice] = useState();
  const [secondHouseBidPrice, setSecondHouseBidPrice] = useState();
  const [usedBidPrice, setUsedBidPrice] = useState();
  const [usedAskPrice, setUsedAskPrice] = useState();
  const [productType, setProductType] = useState(0);
  const [websitePrice, setWebsitePrice] = useState();
  const [imageData, setImageData] = useState();
  const [description, setDescription] = useState();
  const [count, setCount] = useState(0);
   const [forgot, setForgot] = useState(false);
    const [signup, setSignup] = useState(false);

  const [finalPriceBuy, setFinalPriceBuy] = useState();
  const [finalPriceSell, setFinalPriceSell] = useState();
  const [images, setImages] = useState([]);
  const [sku, setSku] = useState();
  const [upc, setUpc] = useState();
  const [seoTitle, setSeoTitle] = useState('');
  const [metaDescription, setMetaDescription] = useState('');
  const [imageseo, setImageSeo] = useState('');
  const [desc, setDesc] = useState();
  const [keySpecification , setKeySpecification] = useState("");
  const [dealScore , setDealScore] = useState(0);
  const [globalDescription , setGloabalDescription] = useState("");


  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await ExportApi.getProductDescriptions();
        const data = res?.data?.descriptions ?? ""
        setGloabalDescription(data);
      } catch (error) {
        console.error('Error fetching global description data:', error);
      }
    };

     fetchData();
  }, [])

  // Function to fetch and handle single product data
  const HandleGetSingleProductList = () => {

    // Set loading state to true while data is being fetched
    setLoading(true);

    // Check if there's data in localStorage under the key "Compare"
    if (localStorage.getItem("Compare")) {
      // If data exists, parse it and set the "CompareData" state
      let result = JSON.parse(localStorage.getItem("Compare"));
      setCompareData(result);
      let user = JSON.parse(localStorage.getItem("tokenuser"));
      let userIds = user?user.id:""
      // Fetch single product data by its ID
      ExportApi.GetSingleProductData(Params.slug,userIds)
        .then((resp) => {
    
          const data2 = resp.data.Data;
       
  

          // Set various states with data from the response
          setCount(1);
          setSecondHouseAskPrice(data2?.new_second_hand_house_ask);
          setSecondHouseBidPrice(data2?.new_second_hand_house_bid);
          setWebsitePrice(data2?.new_retail_website_price);
          setUsedBidPrice(data2?.used_house_bid);
          setUsedAskPrice(data2?.used_house_ask);
          setProductType(data2?.type);
          if (resp.data.Data.type === 1) {
       
            setFinalPriceBuy(resp.data.Data.new_retail_website_price)
            setFinalPriceSell(resp.data.Data.new_retail_website_price)
          }
          else {
            setFinalPriceBuy(resp?.data?.Data?.lowest_ask)
            setFinalPriceSell(resp?.data?.Data?.highest_bid)
          }
          // setAskAmount(data2?.lowest_ask);
          // setBidAmount(data2?.highest_bid);
          setData(resp?.data?.Data);
          setFilterBrand(resp?.data?.relate);

          // Fetch all products
          // ExportApi.GetAllProduct()
          //   .then((res) => {
          //     const data = res.data.details;
      
          //     // Filter products based on brand and exclude the current product
          //     const result2 = data?.filter(
          //       (item) => item.brand == data2.brand && item._id != data2._id
          //     );
          //     // Update the "isCompare" property of filtered products
          //     for (let i = 0; i < result.length; i++) {
          //       const element = result[i];
          //       for (let index = 0; index < result2.length; index++) {
          //         const element1 = result2[index];
          //         if (element?._id.includes(element1?._id)) {
          //           data[index].isCompare = true;vvv
          //         }
          //       }
          //     }
              // Set the "FilterBrand" state with the filtered products
              // setTimeout(() => {
              //   setFilterBrand([...result2]);
              // });
              // Set the "Count" state
        //       setCount(1);
        //     })
        //     .catch((err) => console.log(err));
         })
      .catch((err) => console.log(err));
    } else {
      // If no data exists in localStorage under the key "Compare"
      let user = JSON.parse(localStorage.getItem("tokenuser"));
      // Fetch single product data by its ID
      let userIds = user?user.id:""
      ExportApi.GetSingleProductData(Params.slug,userIds)
        .then((resp) => {

          const data2 = resp.data.Data;
          const dealScore =
            data2?.lowest_ask && data2?.benchmark_score &&
              Number(data2.lowest_ask) !== 0 &&
              Number(data2.benchmark_score) !== 0
              ? Number(data2.benchmark_score) / Number(data2.lowest_ask)
              : 0;

          setDealScore(dealScore)
          setDesc(data2?.description);
          setKeySpecification(data2?.key_specifications)
          setSku(data2?.sku)
          setUpc(data2?.upc)
          setImages(resp?.data?.Data.image[0]);
          setCount(1);
          // Set various states with data from the response
          setSecondHouseAskPrice(data2.new_second_hand_house_ask);
          setSecondHouseBidPrice(data2.new_second_hand_house_bid);
          setWebsitePrice(data2.new_retail_website_price);
          setUsedBidPrice(data2.used_house_bid);
          setUsedAskPrice(data2.used_house_ask);
          setProductType(data2.type);
          setImageData(data2.image);
          setData(resp.data.Data);
          if (resp.data.Data.type === 1) {
            setFinalPriceBuy(resp.data.Data.new_retail_website_price)
            setFinalPriceSell(resp.data.Data.new_retail_website_price)
          }
          else {
            setFinalPriceBuy(resp?.data?.Data?.lowest_ask)
            setFinalPriceSell(resp?.data?.Data?.highest_bid)
          }
          setFilterBrand(resp?.data?.relate);
          // Set loading state to false since data fetching is complete
          setLoading(false);
        })
        .catch((err) => console.log(err));
    }
  };


 

  // Function to fetch and handle single product data with user-specific ID
  const HandleGetSingleProductList1 = (id) => {
    // Set loading state to true while data is being fetched
    setLoading(true);

    // Check if there's data in localStorage under the key "Compare"
    if (localStorage.getItem("Compare")) {
      // If data exists, parse it and set the "CompareData" state
      let result = JSON.parse(localStorage.getItem("Compare"));
      setCompareData(result);
      // Fetch single product data by its ID with the user-specific ID
      ExportApi.HandleGetSingleUserProduct(Params.slug, id)
        .then((resp) => {
   
          setCount(1);
          const data2 = resp.data.Data;
      
          // Set various states with data from the response
          setSecondHouseAskPrice(data2?.new_second_hand_house_ask);
          setSecondHouseBidPrice(data2?.new_second_hand_house_bid);
          setWebsitePrice(data2?.new_retail_website_price);
          setProductType(data2?.type);
          setImageData(data2?.image);
          setUsedBidPrice(data2?.used_house_bid);
          setUsedAskPrice(data2?.used_house_ask);
          setData(resp?.data?.Data);
          // setAskAmount(data2.lowest_ask);
          // setBidAmount(data2.highest_bid);
          setFilterBrand(resp?.data?.relate);
          // Fetch all products
          const result2 = resp?.data?.relate;
        })
        .catch((err) => console.log(err));
    } else {
      // If no data exists in localStorage under the key "Compare"

      // Fetch single product data by its ID with the user-specific ID
      ExportApi.HandleGetSingleUserProduct(Params.slug, id)
        .then((resp) => {
          const data2 = resp.data.Data;
         
             setSeoTitle(data2?.seoTitle);
             setMetaDescription(data2?.metaDescription)
             setImageSeo(data2?.image[0]);
       
            
          // Set various states with data from the response
          setData(data2);
          setDescription(data2.description);
          setKeySpecification(data2?.key_specifications)
          setCount(1);
          setSecondHouseAskPrice(data2.new_second_hand_house_ask);
          setSecondHouseBidPrice(data2.new_second_hand_house_bid);
          setWebsitePrice(data2.new_retail_website_price);
          setProductType(data2.type);
          setUsedBidPrice(data2.used_house_bid);
          setUsedAskPrice(data2.used_house_ask);
          setImageData(data2?.image);
          setFilterBrand(resp?.data?.relate);
          const result = resp?.data?.relate  
        })
        .catch((err) => console.log(err));
    }
  };

  // Start close the Login Modal
  const handleClose = () => {
    // This function is used to close a login modal
    // Set the "show" state to false
    setShow(false);
  };

  // Function to show the login modal
  const handleShow = () => {
    // This function is used to display or show the login modal
    // Set the "show" state to true
    setShow(true);
  };

  // Function to handle favorite button clicks
  // data is a boolean value that indicates whether the item is being added to favorites (true) or removed from favorites
  // id represents the unique identifier of the item for which the favorite button is being clicked
  const HandleFavButton = (data, id) => {
    // Delay the execution of the code inside to ensure the UI updates correctly
    setTimeout(() => {
      // Check if a user is logged in (either as a user or admin)
      if (localStorage.getItem("tokenuser") || localStorage.getItem("admin")) {
        if (data) {
          // If data is truthy (indicating that the item is being added to favorites)
          // Create a copy of the existing data
          let newData = Data;
          // Update the 'isfav' property in the copied data to true
          newData.isfav = data;
          // Update the component's state with the new data
          setData({ ...newData });
          // Call the function to add the item to favorites
          HandleAddtoFav(id);
        } else {
          // Create a copy of the existing data
          let newData = Data;
          // Update the 'isfav' property in the copied data to false
          newData.isfav = data;
          // Update the component's state with the new data
          setData({ ...newData });
          // Call the function to remove the item from favorites
          HandleRemovetoFav(id);
        }
      } else {
        // If no user is logged in, show the login modal
        handleShow();
      }
    });
  };

  // Function to add an item to favorites
  // The 'id' parameter represents the unique identifier of the item to be added to favorites
  const HandleAddtoFav = (id) => {
    // Check if a user is logged in as a regular user (tokenuser)
    if (localStorage.getItem("tokenuser")) {
      // If a regular user is logged in, call the API to add the item to their favorites

      // Retrieve the user's ID from local storage
      const userId = JSON.parse(localStorage.getItem("tokenuser")).id;

      // Call the API to add the item to the user's favorites
      ExportApi.AddtoFevreat(id, userId)
        .then((resp) => {
          // Handle the API response if needed (empty in this example)
        })
        .catch((err) => {
          // Handle any errors that occur during the API call
          console.log(err);
        });
    } else {
      // If no regular user is logged in, assume it's an admin

      // Retrieve the admin's ID from local storage
      const adminId = JSON.parse(localStorage.getItem("admin")).id;

      // Call the API to add the item to the admin's favorites
      ExportApi.AddtoFevreat(id, adminId)
        .then((resp) => {
          // Handle the API response if needed (empty in this example)
        })
        .catch((err) => {
          // Handle any errors that occur during the API call
          console.log(err);
        });
    }
  };

  // Function to remove an item from the user's favorites
  const HandleRemovetoFav = (id) => {
    // The 'id' parameter represents the unique identifier of the item to be removed from favorites

    // Check if a user is logged in as a regular user (localStorage.getItem("tokenuser"))
    if (localStorage.getItem("tokenuser")) {
      // If a regular user is logged in, call the API to remove the item from their favorites
      ExportApi.RemovetoFevreat(
        id,
        JSON.parse(localStorage.getItem("tokenuser")).id
      )
        .then((resp) => {
          // Handle the API response if needed (empty in this example)
        })
        .catch((err) => console.log(err)); // Handle any errors that occur during the API call
    } else {
      // If no regular user is logged in, assume it's an admin (localStorage.getItem("admin"))

      // Call the API to remove the item from the admin's favorites
      ExportApi.RemovetoFevreat(
        id,
        JSON.parse(localStorage.getItem("admin")).id
      )
        .then((resp) => {
          // Handle the API response if needed (empty in this example)
        })
        .catch((err) => console.log(err)); // Handle any errors that occur during the API call
    }
  };

  // Function to retrieve related products for comparison
  const RelatedProductCompare = () => {
    // Check if a regular user is logged in (localStorage.getItem("tokenuser"))
    if (localStorage.getItem("tokenuser")) {
      // If a regular user is logged in, call the HandleGetSingleProductList1 function
      // with the user's ID obtained from the user token
      HandleGetSingleProductList1(
        JSON.parse(localStorage.getItem("tokenuser")).id
      );
    }
    // Check if an admin is logged in (localStorage.getItem("admin"))
    else if (localStorage.getItem("admin")) {
      // If an admin is logged in, call the HandleGetSingleProductList1 function
      // with the admin's ID obtained from the admin token
      HandleGetSingleProductList1(JSON.parse(localStorage.getItem("admin")).id);
    }
    // If no user or admin is logged in
    else {
      // Call the HandleGetSingleProductList function without any specific user ID
      HandleGetSingleProductList();
    }
  };

  const HandleGetAskList = (slug) => {
    ExportApi.handleLowestBid(slug).then((resp) => {
      if (resp.data.message == "Data Fetched successfully") {
        setAskAmount(resp.data.data[0]?.askAmount)
      } else {
        setAskAmount()
      }
    })
  }

  const HandleGetBidList = (slug) => {
    ExportApi.handleHighestBid(slug).then((resp) => {
      if (resp.data.message == "Data Fetched Successfully") {
        setBidAmount(resp.data.data[0]?.bidAmount)
      } else {
        setBidAmount()
      }
    })
  }


  // This useEffect is used to initialize the "Compare" state with data from localStorage.
  // It runs once when the component is mounted.
  useEffect(() => {
    // Check if there is data in localStorage under the key "Compare"
    if (localStorage.getItem("Compare")) {
      // If data exists in "Compare" key, parse it and set it as the "Compare" state.
      setCompare(JSON.parse(localStorage.getItem("Compare")));
    }
  }, []);

  useEffect(() => {
    console.log(Params, Params.slug ,  "Pramasssssssss")
    // Check if a regular user is logged in by looking for a user token in localStorage
    if (localStorage.getItem("tokenuser")) {

      // If a regular user is logged in, call the "HandleGetSingleProductList1" function
      HandleGetSingleProductList1(
        JSON.parse(localStorage.getItem("tokenuser")).id      );
      HandleGetSingleProductList();
      HandleGetAskList(Params.slug)
      HandleGetBidList(Params.slug)
    }
    // Check if an admin is logged in by looking for an admin token in localStorage
    else if (localStorage.getItem("admin")) {
      // If an admin is logged in, call the "HandleGetSingleProductList1" function

      HandleGetSingleProductList1(
        JSON.parse(localStorage.getItem("admin")).id      );
      HandleGetSingleProductList();

      HandleGetAskList(Params.slug)
      HandleGetBidList(Params.slug)
    }
    // If neither a regular user nor an admin is logged in
    else {
      // This likely retrieves generic single product data when no user is authenticated.
   
      HandleGetSingleProductList();
      HandleGetAskList(Params.slug)
      HandleGetBidList(Params.slug)
    }

    if (localStorage.getItem("tokenuser")) {
      var userIdRecentlyViewed = JSON.parse(localStorage.getItem("tokenuser"))?.id
    } else {
      var userIdRecentlyViewed = JSON.parse(localStorage.getItem("admin"))?.id
    }

    ExportApi.updateRecentlyViewedProduct(userIdRecentlyViewed, Params?.slug)
      .then((resp) => {
        if (resp?.data?.message == "Data Updated successfully") {
            
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [Params.slug]);


  useEffect(() => {
    // This effect runs once when the component mounts (empty dependency array [])

    // Adding an event listener to the 'window' object
    window.addEventListener("LoginEv", () => {
      // This code block is executed when the "LoginEv" event is triggered

      // Call the handleClose function to close the modal
      handleClose();
    });
  }, []);

  // This useEffect is used to scroll the window to the top when the component is mounted.
  // It runs once when the component is mounted.

  useEffect(() => {
    // Use the window.scrollTo() method to scroll the window to the top.
    // The parameters (0, 0) represent the X and Y coordinates, respectively,
    // where (0, 0) is the top-left corner of the window.
    window.scrollTo(0, 0);
  }, []);


  // Event listener for the "Login" event
  window.addEventListener("Login", () => {
    // This event listener is triggered when the "Login" event occurs.

    // Check if a regular user is logged in
    if (localStorage.getItem("tokenuser")) {
      // If a regular user is logged in, call "HandleGetSingleProductList1" after a short delay
      setTimeout(() => {
        HandleGetSingleProductList1(
          JSON.parse(localStorage.getItem("tokenuser")).id
        );
      });
    } else {
      // If no regular user is logged in, assume it's an admin

      // Call "HandleGetSingleProductList1" for the admin after a short delay
      setTimeout(() => {
        HandleGetSingleProductList1(
          JSON.parse(localStorage.getItem("admin")).id
        );
      });
    }
  });

  // Event listener for the "Loginout" event
  window.addEventListener("Loginout", () => {
    // This event listener is triggered when the "Loginout" event occurs.

    // Call "HandleGetSingleProductList" after a short delay
    setTimeout(() => {
      HandleGetSingleProductList();
    });
  });

  // useEffect to handle the browser's popstate event (e.g., when the user clicks the back button)
  useEffect(() => {
    const handlePopState = () => {
      // This function will be called when the user clicks the back button in the browser.

      // Navigate back (-1) in the browser history
      navigate(-1);
      // You can perform any necessary actions here when the back button is clicked
    };

    // Attach the event listener for the browser's popstate event
    window.addEventListener("popstate", handlePopState);

    // Clean up the event listener when the component unmounts to avoid memory leaks
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);


  return (
    <div className="custom-font">
      <Helmet>
        <title>{seoTitle && seoTitle != "null" && seoTitle != "" ? seoTitle : "Gpuwiz"}</title>
        <meta name="description" content={metaDescription && metaDescription != "null" && metaDescription != "" ? metaDescription : "GPU"} />
        {imageseo && <meta property="og:image" content={imageseo} />}
      </Helmet>

      <Header />
      <Container style={{ paddingTop: 'clamp(20px, 5vw, 48px)', paddingBottom: '3px' }}>
        <Row style={{ margin: 0 }}>
          <Col xs="12" md="8">
            {count == 0 ? (
              ""
            ) : (
              <>
              <h1 
              style={{ 
                fontSize: 'clamp(24px, 4vw, 32px)', 
                marginBottom: '0px',
                lineHeight: '1.2',
                color: '#262626', 
                fontWeight : 700
              }}
              // className="text-center text-4xl md:text-5xl font-bold mb-2 text-foreground"
               >
                {`${Data?.brand}  ${Data?.series} ${Data?.model}`}
              </h1>
              
              {/* MPN */}
              <p style={{ 
                fontSize: 'clamp(14px, 2vw, 16px)', 
                fontWeight: 500,
                marginBottom: '0px',
                color: '#262626',
              }}>
                 {sku !== "undefined" && sku !== "" ? <>MPN: {sku}</> : ""}
               </p> 

               {/* UPC */}
               <p style={{ 
                   fontWeight: 500, 
                   marginBottom: '0px',
                   padding: 0,
                   fontSize: 'clamp(14px, 2vw, 16px)',
                   color: '#262626',
                 }}>
                 {upc !== "undefined" && upc !== "" ? <>UPC: {upc}</> : ""}
                 </p> 
              </>
            )}
            <p style={{ 
              fontSize: 'clamp(14px, 2vw, 16px)',
              marginBottom: 'clamp(8px, 2vw, 12px)',
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              gap: 'clamp(4px, 1vw, 8px)',
              fontWeight: 600,
              color: '#00427A'
            }}>
              <span>Condition :</span>
              <span> 
              {Data?.type == 2 ? " New(Resale)" : " Used(Tested)"}
              </span>

              {/* Info Icon with Tooltip */}
              <span style={{ display: 'inline-flex', alignItems: 'center', color: 'black' }} className="custom-font">
                <ReactTooltip
                  className="custom-tooltip text-center"
                  anchorId="condition-tooltip"
                  place="bottom"
                  style={{ maxWidth: "240px" }}
                  clickable={true}
                  closeOnScroll={false}
                  content={
                    Data?.type == 2 ? (
                      <>
                        This Item is brand new and sealed, sold by a third party seller. Box may have prior
                        ownership or retail labels. OEM manufacturer warranty is not guaranteed and may vary by
                        brand. GPUwiz will verify item meets our New (Resale) condition requirements prior to
                        shipment.{" "}
                        <a
                          href={`${process.env.REACT_APP_REDIRECT_URI}/help/quality-standards`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "underline" }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          Learn more
                        </a>
                      </>
                    ) : (
                      <>
                        GPUwiz Verified. Meets GPUwiz Quality Standards. We physically test each card at stock
                        settings: fans (RPM sweep), ports, artifact-free bench, power/clock near spec, temps &
                        hotspot delta in range; cosmetics meet standard. Serial logged. Includes the GPUwiz
                        Verified Test Card. Manufacturer warranty is not guaranteed and may vary by brand.{" "}
                        <a
                          href={`${process.env.REACT_APP_REDIRECT_URI}/help/quality-standards`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ textDecoration: "underline" }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          Learn more
                        </a>
                      </>
                    )
                  }
                />
                <span id="condition-tooltip" style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
                  <QuestionMarkSvg />
                </span>
              </span>

            </p>
          </Col>

          {/* Heart and Share Button */}
          <Col xs="12" md="4">
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'flex-end',
              gap: 'clamp(12px, 3vw, 20px)',
              marginBottom: 'clamp(12px, 3vw, 20px)'
            }}>
              <Heart
                isActive={Data?.isfav}
                onClick={() => HandleFavButton(!Data.isfav, Data._id)}
                animationScale={1.25}
                style={{ width: 'clamp(18px, 4vw, 24px)', height: 'clamp(18px, 4vw, 24px)' }}
              />
              <button
                style={{ 
                  border: 'none', 
                  background: 'transparent', 
                  padding: 0, 
                  display: 'flex', 
                  alignItems: 'center',
                  cursor: 'pointer'
                }}
                onClick={() => setModalShow(true)}
              >
                <IoShareOutline style={{ width: 'clamp(18px, 4vw, 24px)', height: 'clamp(18px, 4vw, 24px)' }} />
              </button>
            </div>
          </Col>
        </Row>
      </Container>
      {/* Start Buy Sell Price Component */}
      <Buysell
        prm={Data?.slug}
        Bid={bidAmount}
        Ask={askAmount}
        type={productType}
        website={websitePrice}
        HouseAskprice={secondHouseAskPrice}
        HouseBidPrice={secondHouseBidPrice}
        Image={imageData}
        count={count}
        usedask={usedAskPrice}
        usedbid={usedBidPrice}
        finalPriceBuy={finalPriceBuy}
        FinalPriceSell={finalPriceSell}
        dealScore={dealScore}
        types={Data?.type}
        brand={Data?.brand}
        series={Data?.series}
        model={Data?.model}
        sku={sku}
        upc={upc}
        desc={desc}
        globalDescription={globalDescription}
        imageData={imageData}
      />

      <Container style={{ paddingTop: 0, paddingBottom: 0 }}>
      <Col lg={12} style={{ padding: 'clamp(8px, 2vw, 16px)' }}>
      <Newbuysell
        Bid={bidAmount}
        Ask={askAmount}
        type={productType}
        website={websitePrice}
        HouseAskprice={secondHouseAskPrice}
        HouseBidPrice={secondHouseBidPrice}
        Image={imageData}
        count={count}
        usedask={usedAskPrice}
        usedbid={usedBidPrice}
        finalPriceBuy={finalPriceBuy}
        FinalPriceSell={finalPriceSell}
      />
      

        {/* Deal Score & GPUwiz Verified */}
        {/* <div style={{ 
          display: 'flex', 
          flexDirection: 'column',
          gap: 'clamp(12px, 3vw, 16px)',
          alignItems: 'flex-start'
        }}>
          <span style={{ 
            display: 'flex', 
            flexDirection: 'row',
            gap: 'clamp(8px, 2vw, 12px)',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            <WarningSvg />
            <p style={{ 
              fontSize: "clamp(16px, 2vw, 20px)", 
              fontWeight: 600, 
              color: "#262626", 
              textAlign: "center", 
              marginBottom: "0px",
              fontFamily: 'custom-font'
            }}>
              Deal Score: {dealScore && dealScore !== 0 ? dealScore?.toFixed(2) : "Not Available"}
            </p>
            <ReactTooltip
              className="custom-tooltip text-center"
              anchorId="deal-score-tooltip"
              place="bottom"
              style={{ maxWidth: "240px", fontFamily: 'custom-font' }}
              clickable={true}
              closeOnScroll={false}
              content="Higher Deal Score means better value. It measures performance per dollar using the live price and the model's benchmark score."
            />
            <span id="deal-score-tooltip" className="d-flex align-items-center justify-content-center" style={{ cursor: "pointer" }}>
              <QuestionMarkSvg />
            </span>
          </span>

          {Data?.type !== 2 && (
            <span style={{ 
              display: 'flex', 
              flexDirection: 'row',
              gap: 'clamp(8px, 2vw, 12px)',
              alignItems: 'flex-start'
            }}>
              <svg 
                width="20" 
                height="20" 
                viewBox="0 0 24 24" 
                fill="#1fa940" 
                style={{ marginTop: "2px", flexShrink: 0, width: 'clamp(18px, 4vw, 20px)', height: 'clamp(18px, 4vw, 20px)' }}
              >
                <circle cx="12" cy="12" r="11" stroke="#1fa940" strokeWidth="2" fill="none" />
                <path
                  d="M7 12l3.5 3.5L17 9"
                  stroke="#1fa940"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div style={{ color: '#262626', fontFamily: 'custom-font' }}>
                <div style={{ 
                  fontWeight: 600, 
                  color: '#262626', 
                  fontSize: 'clamp(16px, 3vw, 20px)',
                  marginBottom: 'clamp(4px, 1vw, 8px)'
                }}>
                  GPUwiz Verified
                </div>
                <small style={{ 
                  display: 'block', 
                  color: '#666',
                  fontSize: 'clamp(12px, 2vw, 14px)',
                  lineHeight: '1.5'
                }}>
                  <b>Benchmarked & function checked: fans, <br/>
                  temps/hotspots, artifacts, ports, load.</b>
                </small>
              </div>
            </span>
          )}
        </div> */}
      </Col>
        
        <Col lg={12}>
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column',
            gap: 'clamp(16px, 4vw, 32px)'
          }}>
            <div style={{ width: '100%' }}>
            {
                    keySpecification && keySpecification?.trim() !== "" && (
                        <div className="mb-3">
                            <h4 style={{ 
                              fontSize: 'clamp(20px, 4vw, 20px)', 
                              fontWeight: 600,
                              marginBottom: 0,
                              color: '#262626',
                            }}>Key specifications </h4>
                            <div 
                              style={{
                                fontSize: 'clamp(14px, 2vw, 16px)',
                                lineHeight: '1.6',
                                color: '#262626',
                                marginBottom: 'clamp(12px, 3vw, 16px)',
                              }}
                            dangerouslySetInnerHTML={{ __html: keySpecification }} />
                        </div>
                    )
                }
              
              {
                desc && desc?.trim() !== "" && (
                  <>
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 'clamp(16px, 4vw, 18px)',
                      marginBottom: 'clamp(16px, 4vw, 24px)'
                    }}>
                      <h4 style={{
                        fontSize: 'clamp(20px, 4vw, 20px)',
                        fontWeight: 600,
                        marginBottom: 0,
                        color: '#262626',
                      }}>
                        {/* Product Description */}
                        About this GPU
                        {/* <span style={{ color: 'red', fontSize: "20px" }}> This should be an original generated description to highlight unique features of this specific model</span> */}
                      </h4>

                    </div>

                    <div
                      style={{
                        fontSize: 'clamp(14px, 2vw, 16px)',
                        lineHeight: '1.6',
                        color: '#262626',
                        marginBottom: 'clamp(12px, 3vw, 16px)',
                      }}
                      dangerouslySetInnerHTML={{ __html: desc }}
                    />
                  </>
                )
              }

                <div style={{ 
                  display: 'flex', 
                  flexDirection: 'column',
                  gap: 'clamp(16px, 4vw, 18px)',
                  marginBottom: 'clamp(16px, 4vw, 24px)'
                }}>
                <h4 style={{ 
                  fontSize: 'clamp(20px, 4vw, 20px)', 
                  fontWeight: 600,
                  marginBottom: 0,
                  color: '#262626',
                }}>
                  Buying on GPUwiz
                </h4>
                  
                </div>
                 <div 
                   style={{ 
                     fontSize: 'clamp(14px, 2vw, 16px)',
                     lineHeight: '1.6',
                     color: '#262626',
                   }}
                   dangerouslySetInnerHTML={{ __html: globalDescription || "" }} 
                 />
            </div>
          </div>
        </Col>
        <Col lg={12}>
          {filterBrand?.length > 0 ? (
            <Favourite
              Title={"Related product"}
              filterData={filterBrand}
              RelatedProductCompare={RelatedProductCompare}

            />
          ) : (
            ""
          )}
        </Col>
      </Container>
      <Footer />

      {/* Start  share Modal  */}
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        backdrop={true}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ textAlign: "center" }}>
            Share With Your Friends
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ display: "flex", justifyContent: "space-around" }}>
          <FacebookShareButton url={path}>
            <FacebookIcon size={32} round />
          </FacebookShareButton>
          <TwitterShareButton url={path}>
            <TwitterIcon size={32} round />
          </TwitterShareButton>
          <PinterestShareButton url={path} media={path}>
            <PinterestIcon size={32} round />
          </PinterestShareButton>
          <EmailShareButton url={path}>
            <EmailIcon size={32} round />
          </EmailShareButton>
        </Modal.Body>
      </Modal>

      {/* Start Login Model */}
      <Login
        setSignup={setSignup}
        setForgot={setForgot}
        signup={signup}
        forgot={forgot}
        modal={() => handleClose()}
        show={show}
        setShow={setShow} />
    </div>
  );
}
